import { createSlice} from "@reduxjs/toolkit";

export const counterSlice= createSlice({
    name:"counter",
    initialState:{
        value:1
    },
    reducers:{
        increament:(state)=>{
            state.value = state.value+1;
        },
        decreament:(state)=>{
            state.value = state.value-1;
        }
    }
})

export const {increament,decreament} = counterSlice.actions;
export default counterSlice.reducer;